// extracted by mini-css-extract-plugin
export default {"privacy":"Coin_privacy__c-TPS","listLink":"Coin_listLink__K6aGI"};